import React from "react";
import { useExportStocksMutation } from "@redux/features/stock/stockApi";
import BaseExportModal from "@/components/reusables/Modals/BaseExportModal";
import { useAppDispatch } from "@/redux/hooks";
import { useGetExportableColumnsQuery } from "@redux/features/dfs/dfsApi";
import BaseDatepicker from "@reusables/BaseDatepicker";
import { useTranslation } from "react-i18next";
import { DatepickerDayjs } from "@reusables/BaseDatepicker/types";
import { performExport } from "@redux/features/dfs/thunks";

type SingleStockExportModalProps = {
    isOpen: boolean;
    onClose: () => void;
    stockRecord?: number;
}

export default function SingleStockExportModal(props: SingleStockExportModalProps) {
    const { t } = useTranslation("", { keyPrefix: "inventory.stock.modals.export" });

    const dispatch = useAppDispatch();
    const [exportStock] = useExportStocksMutation();

    const { data: columns = [], isLoading: isColumnsLoading } = useGetExportableColumnsQuery({ module: "stock" });

    const [date, setDate] = React.useState<DatepickerDayjs>();

    return (
        <BaseExportModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            onSubmit={(data) => {
                const stock_record_id = props.stockRecord;
                if (stock_record_id) {
                    dispatch(
                        performExport("stock", () => {
                            return exportStock({
                                email: data.email,
                                filters: {
                                    ids: [stock_record_id],
                                    ...(date && {
                                        date: date?.format("YYYY-MM-DD")
                                    })
                                },
                                columns: data.columns
                            }).unwrap();
                        })
                    );
                }
            }}
        >
            <BaseExportModal.Email />
            <BaseExportModal.ColumnsSelector columns={columns} isLoading={isColumnsLoading} />
            <div>
                <BaseDatepicker
                    label={t("fields.historyReversionDate.label")}
                    placeholder={t("fields.historyReversionDate.placeholder")}
                    disableFuture

                    value={date}
                    onChange={setDate}
                />
            </div>
            <BaseExportModal.ConcurrencyWarning />
            <BaseExportModal.Confirm />
        </BaseExportModal>
    );
}